import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "editableCellSelect"
  }, [_c("a-select", _vm._b({
    class: {
      "has-error": _vm.err
    },
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, "a-select", _vm.$attrs, false), _vm._l(_vm.selectList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      staticStyle: {
        width: "100px"
      },
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _vm.err ? _c("div", {
    staticClass: "err",
    staticStyle: {
      "line-height": "12px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.pleaseSelect")) + " ")]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };